import React, { useState } from 'react';
import '../../App.scss';
import 'antd/dist/antd.css';
import {
    QuestionCircleOutlined,
} from '@ant-design/icons';
import { Typography, Tooltip, Form, Button } from 'antd';
import { TwitterPicker } from 'react-color';

const fmtRgb = ({ r, g, b }) => `rgb(${r}, ${g}, ${b})`;

export const ColorPickerControl = ({ rgbColor, onColorChange, title }) => {
    const [rgb, setRgb] = useState(rgbColor || fmtRgb({ r: 255, g: 0, b: 152, a: 1 }));
    const [loading, setLoading] = useState(false);

    const handleColorChange = async ({ rgb }) => {
        const formattedColor = fmtRgb(rgb);
        setRgb(formattedColor);
        setLoading(true);
        onColorChange && await onColorChange({ rgb });
        setLoading(false);
    }

    return (
        <>
            { title &&
                <span>
                    Team Color&nbsp;
                    <Tooltip title={title}>
                        <QuestionCircleOutlined />
                    </Tooltip>
                </span>
            }
            <div className='row justify-content-center' >
                <TwitterPicker
                    triangle="hide"
                    colors={['#FF0098', '#27AE60', ...TwitterPicker.defaultProps.colors, '#FFFFFF', '#000000',]}
                    color={rgb}
                    onChangeComplete={handleColorChange}
                    width='240px'
                />
            </div>
        </>
    );

}


const TwitterColorPickerInternal = ({ value, onChange, onColorChange, name }) => {
    const defaultColor = fmtRgb({ r: 255, g: 0, b: 152 });
    const [rgb, setRgb] = useState(value || (name === 'fgColor' ? null : defaultColor));

    // Sync internal state with form value only if it changed externally
    React.useEffect(() => {
      const nextRgb = value || (name === 'fgColor' ? null : defaultColor);
      if (nextRgb !== rgb) {
        setRgb(nextRgb);
      }
    }, [value, name, rgb, defaultColor]);

    const handleColorChange = (colorResult) => {
      const { rgb: rgbObj } = colorResult;
      const formattedColor = rgbObj ? fmtRgb(rgbObj) : null;
      if (formattedColor !== rgb) {
        setRgb(formattedColor);
        onColorChange && onColorChange(colorResult);
        if (onChange) {
          onChange(formattedColor);
        }
      }
    }
  
    const showPlaceholder = !value && name === 'fgColor';

    return (
      <div style={{ position: 'relative' }}>
        {showPlaceholder ? (
          <div 
            style={{ 
              padding: '12px', 
              background: '#f5f5f5', 
              borderRadius: '4px', 
              border: '1px dashed #d9d9d9',
              textAlign: 'center',
              color: '#8c8c8c',
              fontSize: '12px'
            }}
          >
            Smart Color Enabled (Automatic Contrast)
          </div>
        ) : (
          <TwitterPicker
            triangle="hide"
            colors={['#FF0098', '#27AE60', ...TwitterPicker.defaultProps.colors, '#FFFFFF', '#000000',]}
            color={rgb || defaultColor}
            onChangeComplete={handleColorChange}
          />
        )}
      </div>
    );
};

export const ColorPickerControlFormItem = ({ title, rgbColor, onColorChange, name = "rgbColor", label }) => {
    return (
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) => prevValues[name] !== currentValues[name]}
      >
        {({ getFieldValue, setFieldsValue }) => {
          const value = getFieldValue(name);
          const isFgColor = name === 'fgColor';

          return (
            <Form.Item
              name={name}
              label={
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                  <span>
                    {label || (isFgColor ? 'Foreground Color' : 'Pick Color')}&nbsp;
                    {title && (
                      <Tooltip title={title}>
                        <QuestionCircleOutlined />
                      </Tooltip>
                    )}
                  </span>
                  {(isFgColor && !!value) && (
                    <Button 
                      size="small" 
                      type="link" 
                      onClick={() => setFieldsValue({ [name]: null })}
                      style={{ padding: 0, height: 'auto', fontSize: '12px' }}
                    >
                      Use Smart Color
                    </Button>
                  )}
                  {isFgColor && !value && (
                    <Button 
                      size="small" 
                      type="link" 
                      onClick={() => setFieldsValue({ [name]: fmtRgb({ r: 255, g: 0, b: 152 }) })}
                      style={{ padding: 0, height: 'auto', fontSize: '12px' }}
                    >
                      Override Smart Color
                    </Button>
                  )}
                </div>
              }
            >
              <TwitterColorPickerInternal onColorChange={onColorChange} name={name} />
            </Form.Item>
          );
        }}
      </Form.Item>
    );
  }
